// Reasons not connected to slides; holdover from ExitIntentV1
export const RECIPES_DECISION = 'RECIPES_DECISION';
export const OTHER = 'OTHER';
